import { LayoutGroup } from "framer-motion";
import * as React from "react";
import { context } from "./api-data";
import { GroupContainer, GroupTitle } from "./group-container";
import { Part } from "./part";

const createContext = context.get("createContext");
const useContext = context.get("useContext");

export function Context({ scaleItems }) {
  return (
    <GroupContainer>
      <LayoutGroup>
        <ul className={"flex flex-col justify-start gap-5 px-5 py-4"}>
          <Part
            data={createContext}
            name={"createContext"}
            scaleItems={scaleItems}
          />
          <Part data={useContext} name={"useContext"} scaleItems={scaleItems} />
        </ul>
      </LayoutGroup>
      <GroupTitle>Context</GroupTitle>
    </GroupContainer>
  );
}
